export default "__VITE_ASSET__D_qq$mRe__"